import { Link } from 'gatsby'
import { Squeeze } from 'react-burgers'
import { goToAnchor } from 'react-scrollable-anchor';
import React, { Component, useContext } from "react"
import styled from "styled-components"

import PropTypes from "prop-types"

import queryString from 'query-string'

import * as functions from '../style/functions'
import * as vars from '../style/vars'

import jpFlag from "../images/jp-flag.svg";
import enFlag from "../images/en-flag.svg";
import chFlag from "../images/ch-flag.svg";


import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/GlobalContextProvider"

const documentGlobal = typeof document !== "undefined" && document

class Header extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.updateIsOpen()


  }

  toggle(then) {
    this.setState((prevState, props) => {
      return { isOpen: !prevState.isOpen }
    }, () => {
      this.updateIsOpen()
      if(then) then()
    });
  }

  updateIsOpen() {
    if( !documentGlobal ) return
    let body = documentGlobal.querySelector('body');
    if (this.state.isOpen) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = '';
    }
  }

  scrollToEnquiry() {
    if( this.state.isOpen ) {
      this.toggle(() => goToAnchor("enquiry"))
    } else {
      goToAnchor("enquiry")
    }

  }

  renderChildren(hierarchy) {
    if (Array.isArray(hierarchy)) {
      return (
        <HeaderNavigationList>
          { hierarchy.map((child, index) => {
            return (
              <HeaderNavigationListItem key={`navigation-child-${index}`}>
                {!!child.url && <Link className="navigation-list-item" to={child.url}>{child.label}</Link>}
                {!child.url && <span className="navigation-list-item">{child.label}</span>}
                { this.renderGrandChildren(child) }
              </HeaderNavigationListItem>
            )
          })}
          <HeaderNavigationListItem className="is-hidden--tablet-down">
            <HeaderEnquire href="#enquiry">{this.props.lang === 'jp' ? '登録する' : this.props.lang === 'ch' ? '立即注册' : 'Enquire Now'}</HeaderEnquire>
          </HeaderNavigationListItem>
        </HeaderNavigationList>
      );
    }

    return null;
  }

  renderGrandChildren(child) {
    if (child.children) {
      return (
        <HeaderNavigationList className="is-grand-children">
          { child.children.map((grandchild, index) => {
            return (
              <HeaderNavigationListItem key={`navigation-grandchild-${index}`}>
                <Link className="navigation-list-item" to={grandchild.url}>{grandchild.label}</Link>
              </HeaderNavigationListItem>
            );
          })}
        </HeaderNavigationList>
      );
    }

    return null;
  }

  render() {

    const { logo, hierarchy, lang } = this.props;



    return (
      <HeaderWrap>
        <HeaderContainer className={this.state.isOpen ? 'is-open' : ''}>
          <div className="left">
            <Squeeze lineHeight={2} lineSpacing={6} padding="1.1rem" active={this.state.isOpen} width="24" color={vars.colors.blank} onClick={() => this.toggle()}></Squeeze>
          </div>

          <HeaderNavigation lang={lang}>
            { this.renderChildren(hierarchy) }
          </HeaderNavigation>

          <HeaderLogo>
            <Link to="/"><img src={logo} alt="One Mastery" className="logo" /></Link>
          </HeaderLogo>

          <div className="right">
            <HeaderEnquire href="#enquiry" className="is-hidden--mobile-up">
            Enquire
            </HeaderEnquire>
          </div>

          {/* Client asked to remove "language bar". See task (only has copy paste from client): https://projects.efront.com.au/projects/4100/tasks/316017
          
          <FlagWrapper >
            <Link to="/" className={lang === 'en' && ('active')} >
            <img src={enFlag} alt="flag"/>
            </Link>
						<Link to="/jp" className={lang === 'jp' && ('active')}>
            <img src={jpFlag} alt="flag"/>
            </Link>
						<Link to="/ch" className={lang === 'ch' && ('active')}>
            <img src={chFlag} alt="flag"/>
            </Link>
          </FlagWrapper> */}

        </HeaderContainer>
        <LogoContainer>
          <Link to="/"><img src={logo} alt="One Mastery" className="logo" /></Link>
        </LogoContainer>
      </HeaderWrap>
    )
  }
}


const LogoContainer = styled.div`
  display: none;

  .logo {
    position: absolute;
    top: 7rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 4;
    width: 20vw;
    max-width: 30rem;
  }

  ${functions.above.tablet`
    display: block;
  `}

`

const HeaderWrap = styled.div`
  height: 4rem;

  .right {
    text-align: right;
    flex: 1 0;

    a {
      float: right;
    }
  }

  .left {
    flex: 1 0;
  }
`

const HeaderContainer = styled.header`
  align-items: center;
  background-color: ${vars.colors.body};
  display: flex;
  font-weight: 500;
  flex: 1 0 100%;
  height: 4rem;
  justify-content: space-between;
  padding: 0.85rem 0.75rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;

  ${functions.above.tablet`
    justify-content: space-around;
    padding: 0;
  `}

  .Burger {
    margin: -0.75rem;
    ${functions.above.tablet`
      display: none;
    `}
  }
`

const HeaderNavigation = styled.nav`
  background: ${vars.colors.body};
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;

  ${functions.below.tablet`
    .is-open & {
      height: calc(100vh - 48px);
    }
  `}

  ${functions.below.tablet`
    flex: 1 0 100%;
    height: 0px;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    top: 4rem;
    transition: height .5s ${vars.easings.easeOutQuint};
    will-change: height;
    z-index: 3;
  `}
`

const HeaderNavigationList = styled.ul`
  align-items: center;
  background-color: ${vars.colors.body};
  color: ${vars.colors.blank};
  display: flex;
  flex-direction: column;
  font-size: 1.6rem;
  justify-content: stretch;
  left: 50%;
  line-height: 3;
  list-style: none;
  position: absolute;
  top: 0;
  margin-top: 2em;
  margin-bottom: 2em;
  transform: translateX(-50%);

  ${functions.below.mobile`
    margin-top: 1vh;
    margin-bottom: 1vh;
  `}

  li {
    flex: 1 0 auto;
    text-align: center;
  }

  &.is-grand-children {
    align-items: center;
    font-size: .8rem;
    left: auto;
    line-height: 4;
    position: relative;
    transform: inherit;
    margin: 0;

    ${functions.above.tablet`
      background-color: ${vars.colors.body};
      display: none;
      flex-direction: column;
      height: auto;
      left: -1rem;
      line-height: inherit;
      position: absolute;
      right: -2rem;
      top: 4rem;
      z-index: 3;
      `}

    ${functions.below.mobile`
      line-height: 2.2;
    `}
  }

  ${functions.above.tablet`
    flex-direction: row;
    font-size: .8rem;
    height: 4rem;
    left: auto;
    margin-top: 0;
    margin-bottom: 0;
    position: relative;
    transform: inherit;
  `}
`

const HeaderNavigationListItem = styled.li`
  display: flex;
  flex-direction: column;
  position: relative;

  &.is-hidden--tablet-down {
    ${functions.below.tablet`
      display: none;
    `}
  }

  .navigation-list-item {
    letter-spacing: .2rem;
    text-decoration: none;
    text-transform: uppercase;
    transition: color .5s ${vars.easings.easeOutQuint};
    will-change: color;

    &:hover {
      color: ${vars.colors.brandPrimary};
    }

    ${functions.above.tablet`
      line-height: 5;
    `}
  }

  .is-grand-children & {
    height: auto;
    padding: 0 1rem;
  }

  ${functions.above.tablet`
    height: 4rem;
    justify-content: center;

    &:hover .is-grand-children {
      display: block;
    }
  `}
`

const HeaderLogo = styled.div`
  display: flex;
  flex: 1.2 1;
  height: 100%;

  a {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
  }

  img {
    max-height: 100%;
    width: 100% ;
  }

  ${functions.above.tablet`
    display: none;
  `}
`

const HeaderEnquire = styled.a`
  align-items: center;
  background: ${vars.colors.brandPrimary};
  background: -webkit-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${vars.colors.brandPrimary};
  background: -o-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${vars.colors.brandPrimary};
  background: -ms-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${vars.colors.brandPrimary};
  background: -moz-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${vars.colors.brandPrimary};
  background: linear-gradient(to left, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${vars.colors.brandPrimary};
  color: #fff;
  display: flex;
  line-height: 1;
  cursor: pointer;
  padding: .5rem;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color .5s ${vars.easings.easeOutQuint}, color .5s ${vars.easings.easeOutQuint};
  will-change: background-color, color;

  li {
    flex: 1 0;
  }

  &:hover {
    background: #FFF;
    color: ${vars.colors.brandPrimary};
  }

  &.is-hidden--mobile-up {
    ${functions.above.tablet`
      display: none;
    `}
  }

  ${functions.above.tablet`
    align-self: center;
    flex-direction: row;
    font-size: .8rem;
    justify-content: stretch ;
  `}
  ${functions.below.tablet`
    font-size: 11px;
    margin-left: .5em;
    margin-right: .5em;
    `}
`

const FlagWrapper = styled.li`
    position: relative;
    margin: 0 10px;
		width: 90px;
		display: inline-block;
		a{
			width: 20px;
			float: left;
			margin: 0 5px;
			display: block;
			opacity: 0.6;
			transition: opacity 0.5s;
			&.active{
				opacity: 1;
			}
			&:hover{
				opacity: 0.8;
			}
						img{
							display: block;


		}
		&:first-of-type {
			margin-left: 0;
		}
		&:last-of-type {
			margin-right: 0;
		}
		}

    ${functions.below.tablet`
      margin-right: 0;
      margin-left: 1vw;
    `}
`


Header.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  logo: PropTypes.string,
}

export default Header
